// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1278":"67e0ece4","4227":"ddd17fbb"}[chunkId] + ".chunk.css";
};